<button (click)="onDepthChartClick()" class="graph mat-elevation-z2">
  <div id="depth-chart" class="plotly-graph" [class]="getGraphClass()"></div>
  @if (!getShowGraphs()) {
    <div>Create dive segements to populate graphs</div>
  }
</button>
